import React from "react";
import { Calculator } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelFixedCostViabilityAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Fixed Cost Viability Diagnostic"
    subtitle="Can current order economics cover fixed operating costs"
    badge="Cost Base"
    Icon={Calculator}
  />
);

export default FunnelFixedCostViabilityAssessmentViewerV2;
